<div class="summary-grid" [ngStyle]="gridStyle">
  <div class="summary-card" *ngFor="let label of labels; let i = index">
    <div class="summary-val" [style.color]="colors[i]">{{ displayCount(i) }}</div>
    <div class="summary-label">{{ label }}</div>
  </div>
</div>
